import * as ngrxOperators from '@ngrx/operators';
const ngrx = window['@ngrx'] || {};
ngrx.operators = ngrxOperators;
window['@ngrx'] = ngrx;
export { ngrxOperators };